import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class DocumentEndpoint extends BaseEndpoint {}
